export const HERO_TEXT = 'Prima cuenta con el sólido respaldo de Credicorp, el grupo financiero líder en el país que tiene más de 130 años de experiencia.';